export default "__VITE_ASSET__DiAjipz0__"